import { Section } from "@/components/Section";

const IMG = "https://customer-assets-wrfwihn1.emergentagent.net/job_asilo-peramore/artifacts/bgxnhzol_ee60a4df-7d48-4164-87b8-a04015cbd60d.jpeg";

export const ChiSiamo = () => (
  <Section id="chi-siamo" eyebrow="Chi Siamo" title="Un servizio educativo esclusivo" image={IMG} tint="bg-[#f7f0e3]">
    <p>
      L'Asilo Nido <span className="font-800 text-slate-800">Per Amore</span> è un asilo nido
      privato situato a San Donato Milanese, in Via Strasburgo 3/B, nato con l'obiettivo di offrire
      un servizio educativo esclusivo, fondato sull'ascolto, sulla cura e sul rispetto delle esigenze
      di ogni bambino e della sua famiglia.
    </p>
    <p className="rounded-2xl bg-rose-100 text-rose-900 font-800 px-5 py-4">
      Accogliamo bambini dai 3 mesi ai 3 anni.
    </p>
    <p>
      Crediamo che i primi anni di vita siano fondamentali per la crescita e lo sviluppo della persona.
      Per questo accogliamo ogni bambino in un ambiente sereno, sicuro e stimolante, dove possa sentirsi
      amato, valorizzato e libero di esplorare il mondo attraverso il gioco, la creatività e le relazioni.
    </p>
    <p>
      Ogni giornata è pensata per favorire lo sviluppo emotivo, cognitivo, motorio e sociale, rispettando
      i tempi e l'unicità di ciascun bambino. Il nostro impegno è costruire un rapporto di fiducia con i
      genitori, offrendo dialogo costante, trasparenza e la certezza di affidare i propri figli a
      professionisti qualificati e appassionati.
    </p>
    <p className="font-800 text-rose-500">Per noi, educare significa crescere insieme, con amore.</p>
  </Section>
);
